import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const arbitrumOne: VToken[] = [
  {
    chainId: 42161,
    address: '0xaDa57840B372D4c28623E87FC175dE8490792811',
    decimals: 8,
    symbol: 'vWBTC_Core',
    underlyingToken: tokens[42161][2],
  },
  {
    chainId: 42161,
    address: '0x68a34332983f4Bf866768DD6D6E638b02eF5e1f0',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[42161][3],
  },
  {
    chainId: 42161,
    address: '0x7D8609f8da70fF9027E9bc5229Af4F6727662707',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[42161][4],
  },
  {
    chainId: 42161,
    address: '0xB9F9117d4200dC296F9AcD1e8bE1937df834a2fD',
    decimals: 8,
    symbol: 'vUSDT_Core',
    underlyingToken: tokens[42161][5],
  },
  {
    chainId: 42161,
    address: '0xAeB0FEd69354f34831fe1D16475D9A83ddaCaDA6',
    decimals: 8,
    symbol: 'vARB_Core',
    underlyingToken: tokens[42161][1],
  },
  {
    chainId: 42161,
    address: '0x9bb8cEc9C0d46F53b4f2173BB2A0221F66c353cC',
    decimals: 8,
    symbol: 'vgmWETH-USDC_Core',
    underlyingToken: tokens[42161][10],
  },
  {
    chainId: 42161,
    address: '0x4f3a73f318C5EA67A86eaaCE24309F29f89900dF',
    decimals: 8,
    symbol: 'vgmBTC-USDC_Core',
    underlyingToken: tokens[42161][9],
  },
  {
    chainId: 42161,
    address: '0x9df6B5132135f14719696bBAe3C54BAb272fDb16',
    decimals: 8,
    symbol: 'vwstETH_LiquidStakedETH',
    underlyingToken: tokens[42161][8],
  },
  {
    chainId: 42161,
    address: '0x246a35E79a3a0618535A469aDaF5091cAA9f7E88',
    decimals: 8,
    symbol: 'vweETH_LiquidStakedETH',
    underlyingToken: tokens[42161][7],
  },
  {
    chainId: 42161,
    address: '0x39D6d13Ea59548637104E40e729E4aABE27FE106',
    decimals: 8,
    symbol: 'vWETH_LiquidStakedETH',
    underlyingToken: tokens[42161][3],
  },
];
